import axios from "axios";
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:8001";

export const API_URLS = {
  rfqSubmit: `${BACKEND_URL}/api/rfq/submit.php`,
  rfqList: `${BACKEND_URL}/api/rfq/list.php`,
  rfqDetail: (id) => `${BACKEND_URL}/api/rfq/detail.php?id=${id}`,
  authLogin: `${BACKEND_URL}/api/auth/login.php`,
  authMe: `${BACKEND_URL}/api/auth/me.php`,
};

export const API = `${BACKEND_URL}/api`;
export const api = axios.create();

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("mal_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;

  const method = (config.method || "get").toLowerCase();
  const url = config.url || "";

  if (url === "/auth/me" || url === `${API}/auth/me`) {
    config.url = API_URLS.authMe;
  } else if (url === "/auth/login" || url === `${API}/auth/login`) {
    config.url = API_URLS.authLogin;
  } else if ((url === "/rfq" || url === `${API}/rfq`) && method === "post") {
    config.url = API_URLS.rfqSubmit;
  } else if ((url === "/rfq" || url === `${API}/rfq`) && method === "get") {
    config.url = API_URLS.rfqList;
  } else {
    const match = url.match(/^\/(?:api\/)?rfq\/([^/?]+)$/);
    if (match && method === "get") {
      config.url = API_URLS.rfqDetail(match[1]);
    }
  }

  return config;
});

api.interceptors.response.use((response) => {
  const url = response.config?.url || "";
  if (url.includes("/api/rfq/submit.php") && response.data && typeof response.data === "object") {
    const data = { ...response.data };
    if (data.id != null && data.rfqs_id == null) {
      data.rfqs_id = data.id;
    }
    delete data.id;
    response.data = data;
  }
  return response;
});

export const formatApiError = (detail) => {
  if (!detail) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e.msg || JSON.stringify(e)).join(" ");
  return String(detail);
};
